import { render } from "./DisplayByStudents.vue?vue&type=template&id=73764e9b&scoped=true"
import script from "./DisplayByStudents.vue?vue&type=script&lang=js"
export * from "./DisplayByStudents.vue?vue&type=script&lang=js"

import "./DisplayByStudents.vue?vue&type=style&index=0&id=73764e9b&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Projects/Web/ecole-alpha.proj/ecole-alpha.2025-2026.web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.28_vue@3.3.8_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73764e9b"]])

export default __exports__